import {
  ISelectCountry,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Button } from "@mui/material";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { countriesList } from "../../../../../services/country.service";
import { useCallback, useEffect, useState } from "react";
import { DonorContactRow } from "./DonorContactRow";
import { listMainGenerics } from "../../../../../services/generic.service";

const translationPath = "page.4uDonation.donors.form.";

export const DonorContacts = () => {
  const { t } = useTranslation();

  const [countries, setCountries] = useState<ISelectCountry[]>([]);

  const [defaultCountry, setDefaultCountry] = useState<ISelectCountry | null>(
    null
  );

  const [defaultGeneric, setDefaultGeneric] = useState<ISelectType | null>(
    null
  );

  const [generics, setGenerics] = useState<ISelectType[]>([]);

  const { sendRequest } = useFetch(countriesList);
  const { sendRequest: sendRequestGenerics } = useFetch(
    (params: { Identifier: string }) => listMainGenerics(params)
  );

  const { control } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "contactsObject",
  });

  const fetchCountries = useCallback(async () => {
    const { data, success } = await sendRequest(null);
    if (data && success) {
      const sortedData = data.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      setCountries(sortedData);
      const brazil = sortedData.find((c) => c.ddiCode === "55");
      if (brazil) {
        setDefaultCountry(brazil);
      } else if (sortedData.length > 0) {
        setDefaultCountry(sortedData[0]);
      }
    }
  }, [sendRequest, setCountries, setDefaultCountry]);

  const fetchGenerics = useCallback(async () => {
    const { data, success } = await sendRequestGenerics({
      Identifier: "DonorContactType",
    });
    if (data && success && data.length > 0) {
      setGenerics(data);
      setDefaultGeneric(data[0]);
    }
  }, [sendRequestGenerics, setGenerics, setDefaultGeneric]);

  useEffect(() => {
    fetchGenerics();
    fetchCountries();
  }, []);

  const handleAddContact = () => {
    append({
      donorContactType: defaultGeneric,
      ddiCode: defaultCountry,
      value: "",
    });
  };

  return (
    <>
      {fields.map((item, index) => (
        <DonorContactRow
          key={item.id}
          index={index}
          remove={remove}
          countries={countries}
          generics={generics}
        />
      ))}
      <Button onClick={handleAddContact}>
        {t(translationPath + "new_contact") || "Adicionar Contato"}
      </Button>
    </>
  );
};
